var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.theme() || ""
  var m1 = _vm.theme()
  var m2 = _vm.points_name()
  var m3 = _vm.is_open ? _vm.points_name() : null
  var l0 = _vm.__map(_vm.tableData, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var m4 = _vm.points_name(item.describe)
    return {
      $orig: $orig,
      m4: m4,
    }
  })
  var g0 = _vm.tableData.length == 0 && !_vm.loading
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.isPop = true
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        m2: m2,
        m3: m3,
        l0: l0,
        g0: g0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }